var path = 'areas/shared/views/interrupt-fields/interrupt_TextArea.html';
var html = "<div class=\"form-group form-group-narrow\"> <label class=\"control-label col-sm-3\" ng-show=element.properties.Label for=\"{{ element.name }}\"> {{ element.properties.Label }} </label> <div class=\"controls col-sm-9\"> <textarea class=form-control rows=4 ng-model=element.value ng-disabled=isDisabled ng-change=changed() id=\"{{ element.name }}\">\r\n          </textarea> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/views/interrupt-fields/interrupt_TextArea.html
// module id = 8160599108785999
// module chunks = 1